import api from './api';

const BASE = (id) => `/api/service-orders/service-orders/${id}/activities/`;

/**
 * Fetch paginated activity log for a service order (newest first).
 * @param {number|string} serviceOrderId
 * @param {object} params - optional query params, e.g. { page, page_size, event_type }
 */
export const getActivityLog = (serviceOrderId, params = {}) =>
    api.get(BASE(serviceOrderId), { params }).then((r) => r.data);

/**
 * Post a manual update to the activity log.
 * @param {number|string} serviceOrderId
 * @param {string} message
 * @param {File|null} attachment
 */
export const postManualUpdate = (serviceOrderId, message, attachment = null) => {
    const body = new FormData();
    body.append('message', message);
    if (attachment) body.append('attachment', attachment);
    return api
        .post(BASE(serviceOrderId), body, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((r) => r.data);
};
